import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  campaignsByID: [],
  status: 'idle',
  error: null,
};

const campaignsByIDSlice = createSlice({
  name: 'campaignsByID',
  initialState,
  reducers: {
    setCampaignsByID: (state, action) => {
      state.campaignsByID = action.payload;
      state.status = 'succeeded';
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    setLoading: (state) => {
      state.status = 'loading';
    },
  },
});

export const { setCampaignsByID, setError, setLoading } =
  campaignsByIDSlice.actions;
export default campaignsByIDSlice.reducer;
